// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function touch_y($$event) {
  return Stdlib__Option.map((function (prim) {
    return prim.clientY;
  }), Caml_option.nullable_to_opt($$event.touches.item(0)));
}

function install(root, interact, away, drag) {
  const options = {
    passive: true
  };
  const previous_y = {
    contents: undefined
  };
  const wheel = function ($$event) {
    if ($$event.deltaY !== 0) {
      Curry._1(interact, undefined);
    }
    if ($$event.deltaY < 0) {
      return Curry._1(away, undefined);
    }
    
  };
  const keyboard = function ($$event) {
    const match = $$event.key;
    switch (match) {
      case " " :
        if ($$event.shiftKey) {
          Curry._1(interact, undefined);
          return Curry._1(away, undefined);
        } else {
          return Curry._1(interact, undefined);
        }
      case "ArrowDown" :
      case "End" :
      case "PageDown" :
        return Curry._1(interact, undefined);
      case "ArrowUp" :
      case "Home" :
      case "PageUp" :
        Curry._1(interact, undefined);
        return Curry._1(away, undefined);
      default:
        return;
    }
  };
  const start = function ($$event) {
    Curry._1(interact, undefined);
    previous_y.contents = touch_y($$event);
  };
  const move = function ($$event) {
    const current = touch_y($$event);
    const match = previous_y.contents;
    if (match !== undefined && current !== undefined && current > match) {
      Curry._1(away, undefined);
    }
    previous_y.contents = current;
  };
  const down = function (param) {
    Curry._1(interact, undefined);
    Curry._1(drag, true);
  };
  const up = function (param) {
    Curry._1(drag, false);
  };
  const local_0 = [
    "wheel",
    wheel
  ];
  const local_1 = {
    hd: [
      "keydown",
      keyboard
    ],
    tl: {
      hd: [
        "focusin",
        (function (param) {
          const inner = param.target.getBoundingClientRect();
          const outer = root.getBoundingClientRect();
          if (inner.top < outer.top || inner.bottom > outer.bottom) {
            return Curry._1(away, undefined);
          }
          
        })
      ],
      tl: {
        hd: [
          "touchstart",
          start
        ],
        tl: {
          hd: [
            "touchmove",
            move
          ],
          tl: {
            hd: [
              "pointerdown",
              down
            ],
            tl: /* [] */ 0
          }
        }
      }
    }
  };
  const local = {
    hd: local_0,
    tl: local_1
  };
  const global_0 = [
    "pointerup",
    up
  ];
  const global_1 = {
    hd: [
      "pointercancel",
      up
    ],
    tl: {
      hd: [
        "blur",
        up
      ],
      tl: /* [] */ 0
    }
  };
  const $$global = {
    hd: global_0,
    tl: global_1
  };
  Stdlib__List.iter((function (param) {
    root.addEventListener(param[0], param[1], options);
  }), local);
  Stdlib__List.iter((function (param) {
    window.addEventListener(param[0], param[1], options);
  }), $$global);
  return function (param) {
    Stdlib__List.iter((function (param) {
      root.removeEventListener(param[0], param[1]);
    }), local);
    Stdlib__List.iter((function (param) {
      window.removeEventListener(param[0], param[1]);
    }), $$global);
  };
}

export {
  install,
}
/* No side effect */
